<template>
  <section>
    <div class="flex justify-end">
      <Create
        @click="router.push('/group/new')"
        :icon="PhUsersThree"
        :label="'Nova turma'"
        :menu-active="'Lutadores'"
      />
    </div>
    <Transition mode="out-in">
      <div
        v-if="dataTable?.length > 0"
      >
        <section>
          <div class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2">

            <div class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white">
              <SearchInput v-model="searchTerm" />
            </div>

            <DataTable 
              :key="dataTable"
              :data="filteredData"
            >
              <template #head>
                <th scope="col" class="px-6 py-3">Turma</th>
                <th scope="col" class="px-6 py-3">Empresa</th>
                <th scope="col" class="px-6 py-3">Treinamentos</th>
                <th scope="col" class="px-6 py-3 text-center">#</th>
              </template>
            </DataTable>
          </div>
        </section>

      </div>

      <NoDataAnim v-else :label="'Nenhuma turma cadastrada'" />
    </Transition>

    <!-- drawer -->
    <Transition mode="out-in">
      <BaseModal
        :isOpen="isModalOpen"
        @update:isOpen="closeModal"
        :key="modalContent"
      >
        <!-- drawer employee -->
        <div
          id="drawer-right-example"
          class="fixed top-0 right-0 z-40 h-screen overflow-y-auto transition-transform bg-white w-80 overflow-x-hidden"
          :class="{
            'translate-x-0': isModalOpen,
            'translate-x-full': !isModalOpen,
          }"
          tabindex="-1"
          aria-labelledby="drawer-right-label"
        >
          <section>
            <main class="flex flex-col h-screen">
              <!-- header -->
              <div class="bg-gray-100 p-2 pt-0 pb-0">
                <!-- TItulo -->
                <h5
                  id="drawer-right-label"
                  class="inline-flex items-center mb-4 text-lg font-semibold text-gray-600 dark:text-gray-600 mt-3 mr-6"
                >
                  <PhInfo class="w-6 h-6 me-2.5 text-gray-700" />
                  TURMA
                </h5>

                <!-- close button -->
                <button
                  type="button"
                  aria-controls="drawer-right-example"
                  class="text-gray-400 bg-transparent hover:text-gray-700 text-sm w-8 h-8 absolute -end-2 mt-3 mr-2"
                  @click="closeModal"
                >
                  <component :is="PhX" class="w-7 h-6"></component>
                </button>
              </div>

              <!-- content -->
              <section class="p-2">
                <div class="pt-0 pb-0 mb-4">

                  <div class="w-full">
                    <section
                      class="text-lg w-full p-5 pt-0 pb-1 px-1 font-semibold  text-left text-gray-900 bg-white dark:text-gray-600 uppercase"
                    >
                      <small>{{ modalContent?.name }}</small>
                      <p
                        class="text-sm font-normal text-gray-500 dark:text-gray-400 lowercase -mt-0.5"
                      >
                        Informações da turma
                      </p>
                    </section>
                  </div>

                  <div
                    class="flex text-sm pt-2 w-full justify-between font-semibold"
                  >
                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400">
                        Alunos </label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{ modalContent.students_count }}
                      </label>
                    </div>

                    <div class="w-full">
                      <label class="font-medium text-gray-400 text-xs"
                        >Status</label
                      ><br />
                      <label
                        class="text-gray-700 text-sm uppercase"
                        :class="[
                          modalContent?.is_active == 1
                            ? 'text-green-500 font-bold'
                            : 'text-red-500 font-bold'
                        ]"
                      >
                        {{
                          modalContent?.is_active == 1
                          ? 'ATIVO'
                          : 'DESATIVADO'

                        }}
                      </label>
                    </div>
                  </div>

                  <div
                    class="flex text-sm pt-2 w-full justify-between font-semibold"
                  >
                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400">
                        Total de Treinamentos </label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{ modalContent.trainings_count }}
                      </label>
                    </div>
                  </div>

                  <div
                    class="flex text-gray-700 pt-2 w-full justify-between font-semibold mb-2"
                  >
                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400"
                        >Observações</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{ modalContent?.description }}
                      </label>
                    </div>
                  </div>

                  <!-- hr -->

                  <div class="w-full border-t pt-1 border-gray-400 mt-2">
                    <section
                      class="text-lg w-full p-5 pt-0 pb-1 px-1 font-semibold text-left text-gray-900 bg-white dark:text-gray-600 uppercase"
                    >
                      Empresa
                      <p
                        class="-mt-0.5 text-sm font-normal text-gray-500 dark:text-gray-400 lowercase"
                      >
                        Detalhes da empresa
                      </p>
                    </section>
                  </div>

                  <div
                    class="flex text-gray-700 pt-2 w-full justify-between font-semibold"
                  >
                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400"
                        >Empresa</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{
                          modalContent?.companies?.name?.length > 30
                            ? modalContent?.companies?.name.slice(0, 30).concat('...')
                            : modalContent?.companies?.name
                          ?? 'Não informado'
                        }}
                      </label>
                    </div>

                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400"
                        >CNPJ</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase font-bold">
                        {{ modalContent?.companies?.cnpj ?? 'Não informado' }}
                      </label>
                    </div>
                  </div>

                  <div
                    class="flex text-gray-700 pt-2 w-full justify-between font-semibold"
                  >
                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400"
                        >Cidade</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase">
                        {{ modalContent?.companies?.city ?? 'Não informado' }}
                      </label>
                    </div>

                    <div class="w-full">
                      <label class="text-xs font-medium text-gray-400"
                        >Endereço</label
                      ><br />
                      <label class="text-gray-700 text-sm uppercase font-bold">
                        {{ modalContent?.companies?.address ?? 'Não informado' }}
                      </label>
                    </div>
                  </div>

                </div>

              </section>

              <section class="mt-1 sticky bottom-6 shadow bord h-full">
                <div
                  class="h-12 mt-2 bg-gradient-to-t from-white to-transparent pointer-events-none z-10"
                ></div>
                <div class="rounded-3xl rounded-b-none px-3 pt-3 border border-t border-gray-400 bg-white h-full">
                  <!-- title -->
                  <div class="w-full pt-1 mb-3 flex">
                    <div class="h-full flex justify-center">
                      <component class="w-10 h-10 mt-1 text-[#509f2d]" :is="PhFileXls"></component>
                    </div>
                    <section
                      class="text-lg w-full p-5 pt-0 pb-1 px-1 font-semibold text-left text-gray-900 bg-white"
                    >
                      EXPORTAR
                      <p
                        class="-mt-0.5 text-sm font-normal text-gray-500"
                      >
                        Relatório de progresso da turma
                      </p>
                    </section>
                  </div>

                  <!-- buttons -->
                  <!-- :key="modalContent?.status" -->
                  <div  class="grid place-items-center grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1">
                    <button
                      type="button"
                      id="status"
                      class="hover:bg-green-800 border-[#03543f] text-[#03543f] before:bg-[#03543f] focus:outline-none focus:ring-4 focus:ring-green-300 rounded text-sm px-5 py-2.5 text-center me-2 mb-2 font-bold"
                      @click="excel(modalContent?.id, modalContent?.name)"
                      :class="'bg-green-800 border-[#03543f] outline-none ring-2 ring-[#03543f]'"
                    >
                      Gerar Relatório
                    </button>
                  </div>
                </div>
              </section>
            </main>
          </section>
        </div>
      </BaseModal>
    </Transition>

  </section>
</template>

<script setup>
import SearchInput from '@/components/Tables/SearchInput.vue'
import Create from '@/components/Buttons/Create.vue'
import DataTable from './components/DataTableGroup.vue'
import NoDataAnim from '@/components/Lotties/NoDataAnim.vue'
import BaseModal from '@/components/Modals/BaseModal.vue'

import router from '@/router'
import { storeApp } from '@/store'
import { onBeforeMount, ref, computed } from 'vue'
import { UserPlusIcon } from '@heroicons/vue/24/outline'
import { dataFighters } from './store'
import { PdfCreate } from '@/utils/reports/generate-blob'
import { dataGroups } from './store/groups'
import { PhFileXls, PhInfo, PhUsersThree, PhX } from '@phosphor-icons/vue'

const dataTable = computed(() => dataGroups.getters.groups)
const searchTerm = ref('')
const isModalOpen = computed(() => dataGroups.getters.getDrawerModal)
const modalContent = computed(() => dataGroups.getters.getDrawerModalContent)

async function excel (id, name) {
  storeApp.state.loading = true

  const url = `${process.env.VUE_APP_API_URL}app/groups/${id}/report`
  const report = new PdfCreate(url)

  return await report.fetchExcelByItemId(id, name).finally(() => {
    storeApp.state.loading = false
  })
}

const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase()

  return dataTable?.value?.filter((row) => {
    const matchesSearch = !searchTerm.value ||
      ['name', ''].some(
        (key) =>
          row[key] && row[key].toString().toLowerCase().includes(searchTermLower)
      )

    return matchesSearch
  })
})

function closeModal () {
  dataGroups.dispatch('setModalDesactive')
}

onBeforeMount(async () => {
  initFlowbite()

  dataFighters.dispatch('difineConfigsForPage', {
    title: 'Turmas',
    subtitle: 'Gerencie suas turmas'
  })
})

</script>

<style scoped lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}

#status {
 padding: 0.8em 0.8em;
 position: relative;
 overflow: hidden;
 background-color: transparent;
 text-align: center;
 text-transform: uppercase;
 font-size: 16px;
 transition: .3s;
 z-index: 1;
 font-family: inherit;
}

#status::before {
  content: '';
  width: 0;
  height: 300%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  transition: .5s ease;
  display: block;
  z-index: -1;
}

#status:hover::before {
 width: 80%;
}

#status:hover {
 color: white;
 font-weight: bold;
}

.bord {
  box-shadow: rgba(0, 0, 0, 0.2) 40px 60px 70px -7px;
}

</style>
